import React, { forwardRef } from 'react';
const Link = forwardRef(function Link({ as, children, testId = 'store-link', ...otherProps }, ref) {
    const Component = as ?? 'a';
    return (React.createElement(Component, Object.assign({ ref: ref, "data-fs-link": true, "data-testid": testId }, otherProps), children));
});
/**
 * This is only being exported to make it easier to use in Storybook.
 * **DON'T** import this directly to use this component, use the default export
 * instead.
 */
export const StorybookLink = Link;
export default Link;
//# sourceMappingURL=Link.js.map